import React from 'react';
import { isForestCoveredLandCategory } from './utils';

const CharacteristicsSection = ({
  displayData,
  setLocalFormData,
  setFormData,
  handbooks,
  isFieldsLocked,
  openPicker,
  clearTableData
}) => {
  const isBonitetRequired = isForestCoveredLandCategory(displayData.katzem);
  return (
    <div className="group-section">
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '10px' }}>
        <h4>Характеристика насаждения общая</h4>
        <button 
          type="button" 
          onClick={() => clearTableData('characteristics')}
          style={{
            background: '#6c757d',
            color: 'white',
            border: 'none',
            padding: '5px 10px',
            borderRadius: '4px',
            cursor: 'pointer',
            fontSize: '12px'
          }}
        >
          Очистить
        </button>
      </div>
      <div>
        <table className="table">
          <thead>
            <tr>
              <th>Категория земель <span className="required">*</span></th>
              <th>Главная порода</th>
              <th>Бонитет {isBonitetRequired && <span className="required">*</span>}</th>
              <th>Тип леса</th>
              <th>ТЛУ</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              {/* Категория земель */}
              <td className="coordinate-cell">
                <div 
                  className={`reference-cell ${isFieldsLocked ? 'locked-field' : ''}`}
                  onClick={() => {
                    if (!isFieldsLocked) {
                      openPicker('katzem', 6);
                    }
                  }}
                  style={{ 
                    minHeight: 60, 
                    height: 'auto',
                    cursor: isFieldsLocked ? 'not-allowed' : 'pointer',
                    background: isFieldsLocked ? '#f8f9fa' : 'transparent',
                    position: 'relative'
                  }}
                >
                  <textarea
                    readOnly
                    value={(() => {
                      const handbook = handbooks.find(h => h.id === 6);
                      if (handbook && handbook.references && displayData.katzem) {
                        const selectedOption = handbook.references.find(r => r.id.toString() === displayData.katzem);
                        return selectedOption ? selectedOption.name : '';
                      }
                      return '';
                    })()}
                    placeholder="☰"
                    style={{
                      border: 'none',
                      outline: 'none',
                      resize: 'none',
                      width: '100%',
                      height: '100%',
                      background: 'transparent',
                      color: displayData.katzem ? '#495057' : '#6c757d',
                      fontStyle: displayData.katzem ? 'normal' : 'italic'
                    }}
                    className={`form-control coordinate-field ${!displayData.katzem ? 'required-field' : ''}`}
                  />
                </div>
              </td>

              {/* Главная порода */}
              <td className="coordinate-cell">
                <div 
                  className="reference-cell locked-field"
                  style={{ 
                    minHeight: 60, 
                    height: 'auto',
                    cursor: 'not-allowed',
                    background: '#f8f9fa',
                    position: 'relative'
                  }}
                  title="Заполняется автоматически по первой породе первого яруса"
                >
                  <textarea
                    readOnly
                    value={(() => {
                      const handbook = handbooks.find(h => h.id === 31);
                      if (handbook && handbook.references && displayData.gporoda) {
                        const selectedOption = handbook.references.find(r => r.id.toString() === displayData.gporoda);
                        return selectedOption ? selectedOption.name : '';
                      }
                      return '';
                    })()}
                    placeholder="Поле заполняется автоматически"
                    style={{
                      border: 'none',
                      outline: 'none',
                      resize: 'none',
                      width: '100%',
                      height: '100%',
                      background: 'transparent',
                      color: displayData.gporoda ? '#495057' : '#6c757d',
                      fontStyle: displayData.gporoda ? 'normal' : 'italic'
                    }}
                    className="form-control coordinate-field"
                  />
                </div>
              </td>

              {/* Бонитет */}
              <td className="coordinate-cell">
                <div 
                  className={`reference-cell ${isFieldsLocked ? 'locked-field' : ''}`}
                  onClick={() => {
                    if (!isFieldsLocked) {
                      openPicker('bonitet', 7);
                    }
                  }}
                  style={{ 
                    minHeight: 60, 
                    height: 'auto',
                    cursor: isFieldsLocked ? 'not-allowed' : 'pointer',
                    background: isFieldsLocked ? '#f8f9fa' : 'transparent',
                    position: 'relative'
                  }}
                >
                  <textarea
                    readOnly
                    value={(() => {
                      const handbook = handbooks.find(h => h.id === 7);
                      if (handbook && handbook.references && displayData.bonitet) {
                        const selectedOption = handbook.references.find(r => r.id.toString() === displayData.bonitet);
                        return selectedOption ? selectedOption.name : '';
                      }
                      return '';
                    })()}
                    placeholder="☰"
                    style={{
                      border: 'none',
                      outline: 'none',
                      resize: 'none',
                      width: '100%',
                      height: '100%',
                      background: 'transparent',
                      color: displayData.bonitet ? '#495057' : '#6c757d',
                      fontStyle: displayData.bonitet ? 'normal' : 'italic'
                    }}
                    className={`form-control coordinate-field ${isBonitetRequired && !displayData.bonitet ? 'required-field' : ''}`}
                  />
                </div>
              </td>

              {/* Тип леса */}
              <td className="coordinate-cell">
                <input
                  type="text"
                  value={displayData.tiplesa || ''}
                  onChange={(e) => {
                    if (!isFieldsLocked) {
                      const newData = { ...displayData, tiplesa: e.target.value };
                      setLocalFormData(newData);
                      if (setFormData) {
                        setFormData(newData);
                      }
                    }
                  }}
                  readOnly={isFieldsLocked}
                  className={`form-control coordinate-field ${isFieldsLocked ? 'locked-field' : ''}`}
                  style={isFieldsLocked ? { background: '#f8f9fa', cursor: 'not-allowed' } : {}}
                  placeholder="Введите тип леса"
                />
              </td>

              {/* ТЛУ */}
              <td className="coordinate-cell">
                <div 
                  className={`reference-cell ${isFieldsLocked ? 'locked-field' : ''}`}
                  onClick={() => {
                    if (!isFieldsLocked) {
                      openPicker('tlu', 13);
                    }
                  }}
                  style={{ 
                    minHeight: 60, 
                    height: 'auto',
                    cursor: isFieldsLocked ? 'not-allowed' : 'pointer',
                    background: isFieldsLocked ? '#f8f9fa' : 'transparent',
                    position: 'relative'
                  }}
                >
                  <textarea
                    readOnly
                    value={(() => {
                      const handbook = handbooks.find(h => h.id === 13);
                      if (handbook && handbook.references && displayData.tlu) {
                        const selectedOption = handbook.references.find(r => r.id.toString() === displayData.tlu);
                        return selectedOption ? selectedOption.name : '';
                      }
                      return '';
                    })()}
                    placeholder="☰"
                    style={{
                      border: 'none',
                      outline: 'none',
                      resize: 'none',
                      width: '100%',
                      height: '100%',
                      background: 'transparent',
                      color: displayData.tlu ? '#495057' : '#6c757d',
                      fontStyle: displayData.tlu ? 'normal' : 'italic'
                    }}
                    className="form-control coordinate-field"
                  />
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default CharacteristicsSection;

